<template>
  <v-container id="data-tables" fluid tag="section">
    <div class="text-right">
      <v-btn color="info" default rounded class="mr-0" @click="addUserbtn">Add user</v-btn>
    </div>

    <base-material-card color="indigo" icon="mdi-account-group" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Users</div>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['userid']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.userid }}</td>
            <td>{{ row.item.created_at }}</td>
            <td>
              <v-btn
                class="px-2 ml-1"
                color="success"
                min-width="0"
                small
                @click="editUser(row.item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="px-2 ml-1"
                color="error"
                min-width="0"
                small
                @click="deleteUser(row.item.id)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>

    <!-- Edit/Add user (Dialog)  -->
    <v-dialog v-model="userDialog" max-width="500">
      <v-card>
        <v-card-title>
          Add/Edit User
          <v-spacer />

          <v-icon aria-label="Close" @click="userDialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="body-1 text-center">
          <v-form v-model="dialogformvalid" @submit.prevent="submituser">
            <v-text-field v-model="dialogform.editid" class="d-none" />
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="dialogform.userid"
                  :rules="[rules.required]"
                  color="secondary"
                  label="Userid"
                  prepend-icon="mdi-face"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="dialogform.email"
                  :rules="[rules.required]"
                  color="secondary"
                  label="E-mail"
                  prepend-icon="mdi-email"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="dialogform.password"
                  :rules="[rules.required]"
                  color="secondary"
                  label="Password"
                  prepend-icon="mdi-account-group"
                />
              </v-col>
            </v-row>

            <v-btn
              type="submit"
              :disabled="!dialogformvalid"
              class="mt-6"
              color="info"
              depressed
              default
              rounded
              @click="userDialog = false"
            >Submit</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "UsersListDataTables",

  data: () => ({
    dialogformvalid: false,
    userDialog: false,
    dialogform: {
      editid: "",
      userid: "",
      email: "",
      password: ""
    },
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    headers: [
      {
        text: "User Id",
        value: "userid"
      },
      {
        text: "Created Date",
        value: "created_at"
      },
      {
        sortable: false,
        text: "Actions",
        value: "actions"
      }
    ],
    items: [],
    search: undefined
  }),
  mounted() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      var self = this;
      this.$http
        .get("/auth/user/list")
        .then(function(response) {
          self.items = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addUserbtn() {
      this.dialogform.editid = "";
      this.dialogform.userid = "";
      this.dialogform.password = "";
      this.dialogform.email = "";
      this.userDialog = true;
    },
    submituser() {
      var self = this;
      if (this.dialogform.editid === "") {
        // create
        this.$http
          .post("/auth/user/add", self.dialogform)
          .then(function(response) {
            self.getUserList();
            self.userDialog = false;
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        // edit
        this.$http
          .post("/auth/user/edit", self.dialogform)
          .then(function(response) {
            self.getUserList();
            self.userDialog = false;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    editUser(item) {
      this.dialogform.editid = item.id;
      this.dialogform.userid = item.userid;
      this.dialogform.email = item.email;
      this.dialogform.password = item.password;
      this.userDialog = true;
    },
    deleteUser(id) {
      if (confirm("Are you sure you want to delete the user")) {
        var self = this;
        this.$http
          .post("/auth/user/delete", { id: id })
          .then(function(response) {
            self.getUserList();
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>
